module.exports = __webpack_public_path__ + "static/media/JC-logo.2004f8ce.png";